import React from 'react';

import { editorTypes } from 'components/FreecodePage/FreecodeLayout/FreecodeLayoutConstants';
import {
  useAppContext,
  useFreecodeContextLayout,
  useFreecodeContextRun,
  useFreecodeContextData,
} from 'hooks/useContext';
import { FreecodePlayer } from 'components/FreecodePlayer/freecodePlayer';
import { SpinnerWrapper } from 'components/Spinner/Spinner';
import { useQueryParams } from 'hooks/useQueryParams';

export default function FreecodeCanvas() {
  const { courseId } = useQueryParams();

  const { isDarkMode } = useAppContext();
  const { editorType } = useFreecodeContextLayout();
  const { testImpl, peekData } = useFreecodeContextData();
  const {
    language,
    codeSolRef,
    runResponse,
    selectLevelToRun,
    setCanvasStep,
    levelToRun,
    setConsoleLogSteps,
    updateAndRunFlow,
  } = useFreecodeContextRun();

  const setLevelToRun = (index) => {
    selectLevelToRun(index);
    if (courseId) updateAndRunFlow(index);
  };

  const humanInputProps = {
    code: codeSolRef.current,
    language: language,
    testId: testImpl.test,
    testImplId: testImpl._id,
    isFreecodeCreator: editorType === editorTypes.creator,
  };

  return (
    <SpinnerWrapper loading={!peekData}>
      <FreecodePlayer
        testImplementation={testImpl}
        levels={runResponse?.decompressed || peekData}
        levelToRun={levelToRun}
        setLevelToRun={setLevelToRun}
        setCurrentStepArg={setCanvasStep}
        isDarkMode={isDarkMode}
        sizeLimitByParent
        humanInputProps={humanInputProps}
        setConsoleLogSteps={setConsoleLogSteps}
      />
    </SpinnerWrapper>
  );
}
